
const stickyNavigationBar = () => {

  //import debounced from "debouncer";
  function debounced(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this,
        args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  var navOpen = function () {
    return document.documentElement.classList.contains('-nav-open');
  }

  var init = function () {
    const header = document.querySelector(".js-site-header");

    var sticky = false;
    var scrollPos = 0;

    // Helper function to get an element's exact position
    var getPosition = function (el) {
      var xPos = 0;
      var yPos = 0;

      while (el) {
        if (el.tagName == "BODY") {
          // deal with browser quirks with body/window/document and page scroll
          var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
          var yScroll = el.scrollTop || document.documentElement.scrollTop;

          xPos += el.offsetLeft - xScroll + el.clientLeft;
          yPos += el.offsetTop - yScroll + el.clientTop;
        } else {
          // for all other non-BODY elements
          xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
          yPos += el.offsetTop - el.scrollTop + el.clientTop;
        }

        el = el.offsetParent;
      }
      return {
        x: xPos,
        y: yPos,
      };
    };

    var stickyDebounced = debounced(function () {
      let positionOfHeader = getPosition(header);

      if (positionOfHeader.y <= -400) {
        sticky = true;
      }

      if (sticky) {
        document.body.classList.add("header-pinned");
        header.addEventListener('transitionend', function(){
          header.style.zIndex = '9';
        })
      }
    }, 30);

    var difference = function (a, b) {
      return Math.abs(a - b);
    };

    var hideSiteMenu = function() {
      var mmenu = document.querySelector(".site-switcher");
      if(mmenu){
        mmenu.classList.remove('-open');
      }
    }

    var detectScrollDirection = debounced(function () {
      var st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > scrollPos) {
        // downscroll code
        if (sticky) {
          var pixelsScrolled = difference(st, scrollPos);
          if (pixelsScrolled > 220) {
            //document.body.classList.remove("header-pinned");
            document.body.classList.remove("pinned--reveal");
            hideSiteMenu();
          }
        }
      } else {
        // upscroll code
        if (sticky) {
          var pixelsScrolled = difference(st, scrollPos);
          if (pixelsScrolled > 60) {
            let navisOpen = navOpen();
            //alert(navOpen);
            if(!navisOpen){
              document.body.classList.add("pinned--reveal");
            }
          }
        }
      }
      scrollPos = st <= 0 ? 0 : st; // For Mobile or negative scrolling*/

      return scrollPos;
    }, 30);

    window.addEventListener("scroll", function () {
      stickyDebounced();
      detectScrollDirection();
    });
  };
  init();

}
stickyNavigationBar();